<template>
  <label :class="['by-radio',{'is-checked':model===label}]" >
    <span class="by-input">
        <span class="by-radio__inner">
            <svg-icon v-if="model===label" size="16" name="a-GroupCopy"></svg-icon>
        </span>
       

      <input
        ref="radio"
        v-model="model"
        :value="label"
        name="ByRadio"
        type="radio"
        class="by-radio__original"v
      />
    </span>
    <slot>
        
    </slot>
    
  </label>
</template>

<script>
import SvgIcon from './SvgIcon.vue';
export default {
  props: {
    label: String,
    
    value: {},
  },
  data() {
    return {
      aaa: "",
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        //console.log("🚀 ~ val", val);
        this.$emit("input", val);
        this.$refs.radio.checked = this.model === this.label;
      },
    },
  },
};
</script>
<style lang="scss" scoped>
 .by-radio{
    margin-right: 5px;
     &:last-child{
          margin-right: 0;
     }
 }
.by-input{
    cursor: pointer;
    vertical-align: middle;
    line-height: 1;
    position: relative;
    margin-right: 5px;
}
.by-radio__inner{
    display:inline-flex;
    border: 1px solid #DCDFE6;
    border-radius: 100%;
    width: 16px;
    height: 16px;
    background-color: rgba(0,0,0,0);
    cursor: pointer;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.by-radio__original {
    opacity: 0;
    outline: 0;
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0;
}
.is-checked{
    .by-radio__inner{
        // background-color: #fff;
        border:none;
    }
    

}
</style>


// WEBPACK FOOTER //
// src/components/public/ByRadio.vue